import {CALL_API} from 'redux/middleware/api'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import {CONFIRM_STEP, GET_STATUS, INIT_STATE} from './'

export function getOnboardStatus() {
  return (dispatch, getState) => {
    const state = getState()
    const {id} = getCurrentSite(state) || {}
    return dispatch({
      [CALL_API]: {
        endpoint: `sites/${id}/onboard/status`,
        method: 'GET',
        types: GET_STATUS
      }
    })
  }
}

export function confirmStep(step) {
  return (dispatch, getState) => {
    const state = getState()
    const {id} = getCurrentSite(state) || {}
    return dispatch({
      [CALL_API]: {
        endpoint: `sites/${id}/onboard/confirm-step`,
        method: 'POST',
        types: CONFIRM_STEP,
        body: {
          step
        }
      }
    })
  }
}

export function initState() {
  return (dispatch, getState) => {
    const state = getState()
    const {id} = getCurrentSite(state) || {}
    return dispatch({
      siteId: id,
      type: INIT_STATE
    })
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/onboard/actions.js